import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Check, Copy } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useRachelMessageActionButtonStyles } from '../../rachelMessageItem.styles';
import { useRachelCopyMessage } from './useRachelCopyMessage';

interface RachelCopyMessageButtonProps {
  text: string;
}

const RachelCopyMessageButton = ({ text }: RachelCopyMessageButtonProps) => {
  const { translate } = useTranslation();
  const { isCopied, copy } = useRachelCopyMessage(text);
  const { classes } = useRachelMessageActionButtonStyles();
  const label = translate(isCopied ? LangEnum.RACHEL_MESSAGE_COPIED : LangEnum.GLOBAL_COPY);

  return (
    <Tooltip TooltipContent={label} tabIndex={-1}>
      <IconButton
        icon={isCopied ? Check : Copy}
        size="small"
        className={classes.actionButton}
        ariaLabel={label}
        onClick={copy}
      />
    </Tooltip>
  );
};

export default RachelCopyMessageButton;
